import { trackEvent } from '../analytics';

/**
 * PDF 다운로드 추적 (GA4로 전환)
 */
export const trackPDFDownload = async ({
  user_id,
  session_id,
  resume_id,
  download_format = 'pdf',
  browser_info = {}
}) => {
  // GA4로 이벤트 전송
  trackEvent.downloadDocument('resume', download_format);
  
  return true;
};

/**
 * 포트폴리오 생성 추적 (GA4로 전환)
 */
export const trackPortfolioCreate = async ({
  user_id,
  session_id,
  resume_id,
  portfolio_id,
  theme = 'default',
  creation_method = 'ai'
}) => {
  // GA4로 이벤트 전송 - 추가 정보는 logEvent를 직접 사용
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'portfolio_create', {
      event_category: 'Portfolio',
      event_label: theme,
      portfolio_id: portfolio_id,
      creation_method: creation_method
    });
  }
  
  console.log('✅ 포트폴리오 생성 추적 완료 (GA4)');
  return true;
};

/**
 * 이력서 조회 추적 (GA4로 전환)
 */
export const trackResumeView = async ({
  user_id,
  session_id,
  resume_id,
  view_source = 'direct'
}) => {
  // GA4로 이벤트 전송
  trackEvent.viewDocument('resume', resume_id);
  
  console.log('✅ 이력서 조회 추적 완료 (GA4)');
  return true;
};

/**
 * 포트폴리오 조회 추적 (GA4로 전환)
 */
export const trackPortfolioView = async ({
  user_id = null,
  portfolio_id,
  view_source = 'direct',
  visitor_info = {}
}) => {
  // GA4로 이벤트 전송
  trackEvent.viewPortfolio(portfolio_id);
  
  console.log('✅ 포트폴리오 조회 추적 완료 (GA4)');
  return true;
};

/**
 * 브라우저 정보 수집 (그대로 유지)
 */
export const getBrowserInfo = () => {
  if (typeof navigator === 'undefined') return {};
  
  return {
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    language: navigator.language,
    cookieEnabled: navigator.cookieEnabled,
    onLine: navigator.onLine,
    screen: {
      width: screen.width,
      height: screen.height,
      colorDepth: screen.colorDepth
    },
    viewport: {
      width: window.innerWidth,
      height: window.innerHeight
    }
  };
};

/**
 * @deprecated 분석 데이터는 이제 Google Analytics 대시보드에서 확인하세요
 */
export const getAnalyticsData = async (filters = {}) => {
  console.warn('⚠️ getAnalyticsData는 더 이상 사용되지 않습니다. Google Analytics 대시보드를 사용하세요.');
  return [];
};

/**
 * @deprecated 통계 요약은 이제 Google Analytics 대시보드에서 확인하세요
 */
export const getActionSummary = async (timeRange = '7d') => {
  console.warn('⚠️ getActionSummary는 더 이상 사용되지 않습니다. Google Analytics 대시보드를 사용하세요.');
  return {
    total_actions: 0,
    unique_users: 0,
    actions_by_type: {},
    daily_breakdown: {}
  };
};

// 이전 버전과의 호환성을 위해 trackUserAction도 유지하되 GA4로 리다이렉트
export const trackUserAction = async ({
  action_type,
  user_id,
  session_id = null,
  resume_id = null,
  portfolio_id = null,
  action_details = {},
  ip_address = null,
  user_agent = null
}) => {
  console.warn('⚠️ trackUserAction은 GA4로 마이그레이션되었습니다.');
  
  // action_type에 따라 적절한 GA4 이벤트 호출
  switch (action_type) {
    case 'pdf_download':
      return trackPDFDownload({ user_id, session_id, resume_id });
    case 'portfolio_create':
      return trackPortfolioCreate({ user_id, session_id, resume_id, portfolio_id });
    case 'resume_view':
      return trackResumeView({ user_id, session_id, resume_id });
    case 'portfolio_view':
      return trackPortfolioView({ user_id, portfolio_id });
    default:
      console.warn(`⚠️ 알 수 없는 action_type: ${action_type}`);
      return true;
  }
};
